import Numeral from "numeral";
const parseFloatToPrice = (price) => {
  return Numeral(price).format("1,000.00$");
};

export default parseFloatToPrice;
